import { ButtonPrimary } from "../../components/NewButtons";
import { useState } from "react";
import { AddAutoAddedProductDrawer } from "./AddAutoAddedProductDrawer";

export const AddAutoAddedProductSelector = () => {
  const [isOpen, setIsOpen] = useState(false);

  return (
    <>
      <ButtonPrimary onClick={() => setIsOpen(true)}>
        Add auto added product
      </ButtonPrimary>
      <AddAutoAddedProductDrawer
        isOpen={isOpen}
        onClose={() => setIsOpen(false)}
      />
    </>
  );
};
